module.exports = __webpack_public_path__ + "img/btn6.45543ddb.png";